import info from "../../info.jsonc"

const contact_methods: { name: string; link: string; icon?: string }[] = info.contact;

export default function Footer() {
  return (
    <footer className="py-8 text-center bg-zinc-950/80 border-t border-zinc-800 flex flex-col items-center justify-center gap-4">
      <div className="flex flex-row items-center justify-center gap-4">
        {contact_methods.map((method) => (
          <div className="flex justify-center gap-6 mb-4" key={method?.name}>
            <a
              href={method?.link}
              target="_blank"
              rel="noreferrer"
              className="text-zinc-400 hover:text-cyan-400 transition-colors"
            >
              <span className="w-6 h-6">
                <i className={method?.icon}></i>
              </span>
            </a>
          </div>
        ))}
      </div>
      <p className="text-zinc-500 text-sm">
        © {new Date().getFullYear()} theace. All rights reserved.
      </p>
    </footer >
  );
}
